export default __webpack_public_path__ + "static/media/arrow.fdabec23.svg";